import { useEffect as l } from "react";
const u = e => ["ArrowDown", "ArrowUp", "Escape", "Tab"].includes(e),
  c = e => {
    const t = e == null ? void 0 : e.querySelectorAll('button:not([disabled]), a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"], input:not([disabled])');
    return t ? Array.from(t) : [];
  },
  f = (e, t) => {
    const n = t.findIndex(r => r === e.target);
    if (n === -1) return;
    const o = t.length,
      s = r => {
        const i = (n + r + o) % o,
          a = t[i];
        e.preventDefault(), a.focus();
      };
    e.key === "ArrowDown" ? s(1) : s(-1);
  },
  w = _ref => {
    let {
      wrapperRef: e,
      setShowItems: t,
      inputRef: n,
      childrenNumber: o = 0
    } = _ref;
    l(() => {
      const s = r => {
        var i, a;
        if (o === 0 || !((i = e.current) != null && i.contains(r.target)) || !u(r.key)) return;
        if (r.key === "Escape") {
          (a = n.current) == null || a.focus(), t(!1);
          return;
        }
        if (r.key === "Tab") {
          t(!1);
          return;
        }
        const d = c(e.current);
        f(r, d);
      };
      return window.addEventListener("keydown", s), () => {
        window.removeEventListener("keydown", s);
      };
    }, [o, n, t, e]);
  };
export { c as getVisibleElements, u as isArrowKey, w as useNavigation };